/**
 * External Imports
 */
import styled from 'styled-components';

export const RoundInfoContainer = styled.section`
  display: flex;
  align-items: center;
  height: 22;
  margin-top: 10px;
  position: absolute;
  width: 100%;
`;

export const FinishRoundTypography = styled.p`
  line-height: 2rem;
  font-size: 1.4rem;
  max-width: 14em;
  margin-left: 1rem !important;
`;

export const StickyFooter = styled.footer`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  position: sticky;
  width: 100%;
  height: 60px;
  bottom: 0;
  border-top: 1px solid #b0b0b0;
  background: #f6f6f6;
  padding: 0.5em 0px;
  z-index: 12;
`;
